function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import RcCheckbox from 'rc-checkbox';
import React, { useEffect, useState } from 'react';
import { cn } from "../../../lib/utils";
import Wave from "../../../lib/wave";
import { CheckIcon } from '@bfe/moly-icons';
import styles from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Checkbox(_ref) {
  var className = _ref.className,
    innerClassName = _ref.innerClassName,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'middle' : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'normal' : _ref$type,
    propChecked = _ref.checked,
    name = _ref.name,
    _ref$defaultChecked = _ref.defaultChecked,
    defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
    indeterminate = _ref.indeterminate,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    children = _ref.children;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  useEffect(function () {
    setStatus(defaultChecked);
  }, [defaultChecked]);
  useEffect(function () {
    if (status !== propChecked) setStatus(propChecked);
  }, [propChecked]);
  return /*#__PURE__*/_jsxs("label", {
    className: cn('flex gap-[8px] items-start transition-all', !disabled ? 'cursor-pointer' : 'cursor-not-allowed', className),
    children: [/*#__PURE__*/_jsxs("span", {
      className: "flex justify-center items-center relative",
      children: [/*#__PURE__*/_jsx(Wave, {
        component: "Checkbox",
        children: typeof propChecked !== 'undefined' ? /*#__PURE__*/_jsx(RcCheckbox, {
          prefixCls: styles.molyCheckbox,
          className: cn('outline-none ring-btn-default focus-visible:ring-[5px]', size === 'small' ? 'sm' : '', "color-".concat(type), indeterminate ? 'indeterminate' : '', innerClassName),
          checked: propChecked,
          disabled: disabled,
          onChange: function onChange(e) {
            setStatus(propChecked);
            _onChange === null || _onChange === void 0 || _onChange(e.nativeEvent, propChecked);
          },
          name: name
        }) : /*#__PURE__*/_jsx(RcCheckbox, {
          prefixCls: styles.molyCheckbox,
          className: cn('outline-none ring-btn-default focus-visible:ring-[5px]', size === 'small' ? 'sm' : '', "color-".concat(type), indeterminate ? 'indeterminate' : '', innerClassName),
          defaultChecked: defaultChecked,
          disabled: disabled,
          onChange: function onChange(e) {
            var _e$target, _e$target2;
            setStatus(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.checked);
            _onChange === null || _onChange === void 0 || _onChange(e.nativeEvent, e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.checked);
          },
          name: name
        })
      }), indeterminate ? /*#__PURE__*/_jsx("div", {
        className: cn('absolute', 'bg-brandColor-bds-brand-700-normal', status ? styles.fadeIn : styles.fadeOut, size === 'small' ? 'w-[7px] h-[7px] ' : 'w-[8px] h-[8px] ', type === 'buy' ? 'bg-greenColor-bds-green-700-normal' : '', type === 'sell' ? 'bg-redColor-bds-red-700-normal' : '', disabled ? 'bg-base-bds-gray-t4-dis' : '')
      }) : /*#__PURE__*/_jsx(CheckIcon, {
        className: cn('text-center absolute', 'text-base-bds-static-black', status ? styles.fadeIn : styles.fadeOut, size === 'small' ? 'w-[14px] text-[7px] font-[500]' : 'w-[16px] text-[8px] font-[700]', type !== 'normal' ? 'text-base-bds-gray-t1-title-revert' : '', disabled ? 'bg-base-bds-gray-t4-dis' : '')
      })]
    }), /*#__PURE__*/_jsx("span", {
      className: cn('font-IBM font-normal text-base-bds-gray-t1-title', size === 'small' ? 'text-[12px] leading-[18px]' : 'text-[14px] leading-[22px]', type === 'buy' ? "".concat(!status ? 'hover:text-greenColor-bds-green-700-normal' : 'text-greenColor-bds-green-700-normal') : '', type === 'sell' ? "".concat(!status ? 'hover:text-redColor-bds-red-700-normal' : 'text-redColor-bds-red-700-normal') : '', disabled ? 'hover:text-base-bds-gray-t3 text-base-bds-gray-t3' : ''),
      children: children
    })]
  });
}